module.exports = __webpack_public_path__ + "static/media/home-reading-logs.501a041a.svg";